var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23.475,
  height: 23.475,
  viewBox: "0 0 23.475 23.475"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-ios-add-circle-outline",
  "data-name": "Icon ionic-ios-add-circle-outline",
  transform: "translate(-3.375 -3.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_427",
  "data-name": "Path 427",
  d: "M21.629,15.619h-4.2v-4.2a.9.9,0,1,0-1.806,0v4.2h-4.2a.865.865,0,0,0-.9.9.874.874,0,0,0,.9.9h4.2v4.2a.875.875,0,0,0,.9.9.9.9,0,0,0,.9-.9v-4.2h4.2a.9.9,0,1,0,0-1.806Z",
  transform: "translate(-1.409 -1.409)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_428",
  "data-name": "Path 428",
  d: "M15.113,4.955A10.153,10.153,0,1,1,7.929,7.929a10.09,10.09,0,0,1,7.184-2.974m0-1.58A11.738,11.738,0,1,0,26.85,15.113,11.736,11.736,0,0,0,15.113,3.375Z",
  fill: "currentColor"
}))));
export { SvgAddCircle as ReactComponent };
export default __webpack_public_path__ + "static/media/addCircle.1d65a3cf19dad3d2648431bae843d1a6.svg";